import { cartFragment } from '../fragments/cartFields';

export const cartBuyerIdentityUpdateMutation = /* GraphQL */ `
  ${cartFragment}
  mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      cart {
        ...CartFields
        buyerIdentity {
          email
          phone
          customer {
            id
          }
          countryCode
          deliveryAddressPreferences {
            ... on MailingAddress {
              address1
              address2
              city
              country
              zip
            }
          }
          preferences {
            delivery {
              deliveryMethod
              pickupHandle
            }
            wallet
          }
        }
        deliveryGroups(first: 1) {
          edges {
            node {
              deliveryOptions {
                handle
                title
                estimatedCost {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`;
